import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const cancelledVodafoneTariffQueryId = 'admin/vodafoneTariff/cancelled';

export const CancelledTab = () => {
  return (
    <VodafoneTariffTable
      queryId={cancelledVodafoneTariffQueryId}
      state={VodafoneTariffState.CANCELLED}
      tabName="cancelled"
    />
  );
};
